
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireecd3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireecd3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("eBhjS", function(module, exports) {
module.exports = new URL("time-2.fb93ff21.png", import.meta.url).toString();

});

parcelRegister("bHJUT", function(module, exports) {
module.exports = new URL("another-npc.cb713ed6.png", import.meta.url).toString();

});

parcelRegister("3UKTR", function(module, exports) {
module.exports = new URL("soup.d80ca473.png", import.meta.url).toString();

});

parcelRegister("iQrU4", function(module, exports) {
module.exports = new URL("the-wheel-of-fortune.268f82f2.png", import.meta.url).toString();

});

parcelRegister("6mj2Q", function(module, exports) {
module.exports = new URL("head-in-the-clouds.373b7817.png", import.meta.url).toString();

});

parcelRegister("cKCfP", function(module, exports) {
module.exports = new URL("time-2.e64cd78f.wav", import.meta.url).toString();

});

parcelRegister("5UOzC", function(module, exports) {
module.exports = new URL("another-npc.e4208ad6.wav", import.meta.url).toString();

});

parcelRegister("12UvK", function(module, exports) {
module.exports = new URL("soup.bd73cb7e.wav", import.meta.url).toString();

});

parcelRegister("kDEt5", function(module, exports) {
module.exports = new URL("the-wheel-of-fortune-1.f6fb1f29.wav", import.meta.url).toString();

});

parcelRegister("5ptAB", function(module, exports) {
module.exports = new URL("the-wheel-of-fortune-2.7301d747.wav", import.meta.url).toString();

});

parcelRegister("eT9hq", function(module, exports) {
module.exports = new URL("head-in-the-clouds.faf1c120.wav", import.meta.url).toString();

});

var $d428798c72dbc0dc$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["gjwvA","song-player.a264f9af.js","l5IWp","time-2.fb93ff21.png","kYFZ9","another-npc.cb713ed6.png","hoJmq","soup.d80ca473.png","hGRzN","the-wheel-of-fortune.268f82f2.png","3aN9R","head-in-the-clouds.373b7817.png","injLD","time-2.e64cd78f.wav","fxv7D","another-npc.e4208ad6.wav","iUQdn","soup.bd73cb7e.wav","NNYXX","the-wheel-of-fortune-1.f6fb1f29.wav","5fKA9","the-wheel-of-fortune-2.7301d747.wav","fz5GY","head-in-the-clouds.faf1c120.wav","aZoo8","eye.cc48873a.svg"]'));


var $eBhjS = parcelRequire("eBhjS");

var $bHJUT = parcelRequire("bHJUT");

var $3UKTR = parcelRequire("3UKTR");

var $iQrU4 = parcelRequire("iQrU4");

var $6mj2Q = parcelRequire("6mj2Q");

var $cKCfP = parcelRequire("cKCfP");

var $5UOzC = parcelRequire("5UOzC");

var $12UvK = parcelRequire("12UvK");

var $kDEt5 = parcelRequire("kDEt5");

var $5ptAB = parcelRequire("5ptAB");

var $eT9hq = parcelRequire("eT9hq");
var $f0da12febdf20ae2$exports = {};
$f0da12febdf20ae2$exports = new URL("eye.cc48873a.svg", import.meta.url).toString();



const $387effe1c19070b5$var$songs = [
    {
        id: "time-2",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($eBhjS))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cKCfP))),
        name: "time 2",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "another-npc",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($bHJUT))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5UOzC))),
        name: "when another npc tells u not to put ur student loan into shitcoin",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "soup",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($3UKTR))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($12UvK))),
        name: "soup (with sula)",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "the-wheel-of-fortune-1",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($iQrU4))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kDEt5))),
        name: "the wheel of fortune i",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "the-wheel-of-fortune-2",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($iQrU4))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5ptAB))),
        name: "the wheel of fortune ii",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "head-in-the-clouds",
        cover: (0, (/*@__PURE__*/$parcel$interopDefault($6mj2Q))),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "head in the clouds",
        tempo: "128 BPM",
        key: "E Minor",
        release: "09.09.24"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    },
    {
        id: "placeholder",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eT9hq))),
        name: "placeholder",
        tempo: "120 BPM",
        key: "C",
        release: "01.01.01"
    }
];
const $387effe1c19070b5$var$audioSection = document.querySelector(".audio-section");
const $387effe1c19070b5$var$audioControls = document.querySelector(".audio-controls-container");
const $387effe1c19070b5$var$audioElement = document.getElementById("audioElement");
const $387effe1c19070b5$var$audioContext = new window.AudioContext();
const $387effe1c19070b5$var$track = $387effe1c19070b5$var$audioContext.createMediaElementSource($387effe1c19070b5$var$audioElement);
const $387effe1c19070b5$var$songNameElement = document.getElementById("song-name");
const $387effe1c19070b5$var$songTempoElement = document.getElementById("song-tempo");
const $387effe1c19070b5$var$songKeyElement = document.getElementById("song-key");
const $387effe1c19070b5$var$songReleaseElement = document.getElementById("song-key");
const $387effe1c19070b5$var$albumCoverElement = document.querySelector(".album-cover");
const $387effe1c19070b5$var$songDownloadElement = document.getElementById("song-download");
const $387effe1c19070b5$var$skipButton = document.querySelector(".skip-button");
const $387effe1c19070b5$var$prevButton = document.querySelector(".prev-button");
const $387effe1c19070b5$var$mainControls = document.querySelector(".main-controls");
const $387effe1c19070b5$var$sliderSection = document.querySelector(".slider-section");
const $387effe1c19070b5$var$slider = document.querySelector(".slider");
const $387effe1c19070b5$var$btnLeft = document.querySelector(".slider__btn--left");
const $387effe1c19070b5$var$btnRight = document.querySelector(".slider__btn--right");
const $387effe1c19070b5$var$audioToggle = document.querySelector(".toggle-audio-button");
let $387effe1c19070b5$var$songIndex;
let $387effe1c19070b5$var$playerDisplay = false;
//play songs
let $387effe1c19070b5$var$songItems;
function $387effe1c19070b5$var$isPhoneSize() {
    // console.log(window.innerWidth);
    return window.innerWidth <= 767;
}
function $387effe1c19070b5$var$setupSongs() {
    $387effe1c19070b5$var$songItems = document.querySelectorAll(".song-item");
    $387effe1c19070b5$var$songItems.forEach((slide)=>slide.remove());
    $387effe1c19070b5$var$songs.forEach((song, i)=>{
        const songItem = document.createElement("div");
        songItem.classList.add("song-item", "slide");
        $387effe1c19070b5$var$slider.appendChild(songItem);
        // const songCover = song.cover;
        if (song.cover) {
            songItem.style.backgroundImage = `url('${song.cover}')`;
            songItem.style.backgroundSize = "contain";
        } else songItem.classList.add("placeholder-song");
        if (!$387effe1c19070b5$var$isPhoneSize()) songItem.style.transform = `translateX(${i * 100}%)`;
    });
    $387effe1c19070b5$var$songItems = document.querySelectorAll(".song-item");
    $387effe1c19070b5$var$songItems.forEach((item, i)=>{
        item.addEventListener("click", ()=>{
            $387effe1c19070b5$var$playSong(i);
            if ($387effe1c19070b5$var$isPhoneSize()) {
                $387effe1c19070b5$var$audioSection.style.display = "block";
                console.log($387effe1c19070b5$var$playerDisplay);
                $387effe1c19070b5$var$toggleAudio();
            }
        });
    });
}
$387effe1c19070b5$var$setupSongs();
function $387effe1c19070b5$var$playSong(index) {
    const song = $387effe1c19070b5$var$songs[index];
    // console.log(song);
    const songSrc = song.src;
    $387effe1c19070b5$var$audioElement.src = songSrc;
    // console.log(songSrc);
    $387effe1c19070b5$var$audioElement.play();
    if ($387effe1c19070b5$var$isPhoneSize()) {
        $387effe1c19070b5$var$audioControls.style.display = "flex";
        $387effe1c19070b5$var$audioToggle.style.display = "block";
    } else $387effe1c19070b5$var$audioControls.style.display = "grid";
    const songName = song.name;
    const songTempo = song.tempo;
    const songKey = song.key;
    const songRelease = song.release;
    const songCover = song.cover;
    $387effe1c19070b5$var$songIndex = index;
    $387effe1c19070b5$var$songNameElement.textContent = `${songName}`;
    $387effe1c19070b5$var$songTempoElement.textContent = `tempo: ${songTempo}`;
    $387effe1c19070b5$var$songKeyElement.textContent = `key: ${songKey}`;
    $387effe1c19070b5$var$songReleaseElement.textContent = `release date: ${songRelease}`;
    $387effe1c19070b5$var$albumCoverElement.style.backgroundImage = `url("${songCover}")`;
    $387effe1c19070b5$var$songDownloadElement.style.display = "block";
    $387effe1c19070b5$var$songDownloadElement.href = songSrc;
    if ($387effe1c19070b5$var$audioContext.state === "suspended") $387effe1c19070b5$var$audioContext.resume();
    $387effe1c19070b5$var$mainControls.style.visibility = "visible";
}
$387effe1c19070b5$var$skipButton.addEventListener("click", function() {
    $387effe1c19070b5$var$playSong((parseInt($387effe1c19070b5$var$songIndex) + 1) % $387effe1c19070b5$var$songItems.length);
});
$387effe1c19070b5$var$prevButton.addEventListener("click", function() {
    $387effe1c19070b5$var$playSong(($387effe1c19070b5$var$songIndex - 1 + $387effe1c19070b5$var$songItems.length) % $387effe1c19070b5$var$songItems.length);
});
//sliider setup
function $387effe1c19070b5$var$setupSlider() {
    if (!$387effe1c19070b5$var$isPhoneSize()) {
        let curSlide = 0;
        const slides = document.querySelectorAll(".slide");
        const maxLength = slides.length;
        $387effe1c19070b5$var$btnRight.addEventListener("click", function() {
            // console.log(curSlide);
            if (curSlide === maxLength - 3) curSlide = 0;
            else curSlide += 1;
            slides.forEach((s, i)=>s.style.transform = `translateX(${100 * (i - curSlide)}%)`);
        });
        $387effe1c19070b5$var$btnLeft.addEventListener("click", function() {
            if (curSlide === 0) curSlide = maxLength - 3;
            else curSlide -= 1;
            slides.forEach((s, i)=>s.style.transform = `translateX(${100 * (i - curSlide)}%)`);
        });
    }
}
$387effe1c19070b5$var$setupSlider();
//fx
//add reset button
//add loading icon
//add visuals for amounts of fx
function $387effe1c19070b5$var$updateAudioParam(param, control) {
    param.value = control.value;
}
function $387effe1c19070b5$var$resetControls(param, control, resetValue = 0) {
    control.value = resetValue;
    $387effe1c19070b5$var$updateAudioParam(param, control);
}
//pan
const $387effe1c19070b5$var$panner = new StereoPannerNode($387effe1c19070b5$var$audioContext);
const $387effe1c19070b5$var$pannerControl = document.getElementById("panner-control");
$387effe1c19070b5$var$pannerControl.addEventListener("input", ()=>{
    $387effe1c19070b5$var$updateAudioParam($387effe1c19070b5$var$panner.pan, $387effe1c19070b5$var$pannerControl);
});
$387effe1c19070b5$var$pannerControl.addEventListener("dblclick", ()=>{
    $387effe1c19070b5$var$resetControls($387effe1c19070b5$var$panner.pan, $387effe1c19070b5$var$pannerControl);
});
//delay
const $387effe1c19070b5$var$delay = $387effe1c19070b5$var$audioContext.createDelay();
$387effe1c19070b5$var$delay.delayTime.value = 0.5;
const $387effe1c19070b5$var$delayControl = document.getElementById("delay-control");
const $387effe1c19070b5$var$feedback = $387effe1c19070b5$var$audioContext.createGain();
$387effe1c19070b5$var$delayControl.addEventListener("input", ()=>{
    $387effe1c19070b5$var$updateAudioParam($387effe1c19070b5$var$feedback.gain, $387effe1c19070b5$var$delayControl);
});
$387effe1c19070b5$var$delayControl.addEventListener("dblclick", ()=>{
    $387effe1c19070b5$var$resetControls($387effe1c19070b5$var$feedback.gain, $387effe1c19070b5$var$delayControl);
});
//distortion
const $387effe1c19070b5$var$distortionControl = document.getElementById("distortion-control"); // Assume you have an input element
const $387effe1c19070b5$var$distortion = $387effe1c19070b5$var$audioContext.createWaveShaper();
function $387effe1c19070b5$var$makeDistortionCurve(amount) {
    const samples = 44100;
    const curve = new Float32Array(samples);
    for(let i = 0; i < samples; i++){
        const x = i * 2 / samples - 1;
        curve[i] = x * (amount + 1);
    }
    return curve;
}
$387effe1c19070b5$var$distortion.oversample = "2x"; // Optional, for smoother sound
function $387effe1c19070b5$var$resetDistortion() {
    $387effe1c19070b5$var$distortionControl.value = 0;
    $387effe1c19070b5$var$distortion.curve = $387effe1c19070b5$var$makeDistortionCurve($387effe1c19070b5$var$distortionControl.value);
}
$387effe1c19070b5$var$distortionControl.addEventListener("input", ()=>{
    $387effe1c19070b5$var$distortion.curve = $387effe1c19070b5$var$makeDistortionCurve($387effe1c19070b5$var$distortionControl.value);
});
$387effe1c19070b5$var$distortionControl.addEventListener("dblclick", ()=>{
    $387effe1c19070b5$var$resetDistortion();
});
//filter
const $387effe1c19070b5$var$filterControl = document.getElementById("filter");
const $387effe1c19070b5$var$filter = $387effe1c19070b5$var$audioContext.createBiquadFilter();
$387effe1c19070b5$var$filterControl.value = 0;
$387effe1c19070b5$var$filter.frequency.value = $387effe1c19070b5$var$filterControl.value;
$387effe1c19070b5$var$filter.type = "allpass";
$387effe1c19070b5$var$filter.frequency.value = $387effe1c19070b5$var$audioContext.sampleRate / 2; // Set to Nyquist frequency
// console.log("filter is neutral");
$387effe1c19070b5$var$filterControl.addEventListener("input", ()=>{
    const value = parseFloat($387effe1c19070b5$var$filterControl.value);
    if (value < 0) {
        $387effe1c19070b5$var$filter.type = "lowpass";
        $387effe1c19070b5$var$filter.frequency.value = 100 + Math.exp((100 + value) / 10); // Exponential scaling for lowpass
    // console.log(value);
    // console.log(filter.frequency.value);
    } else if (value > 0) {
        $387effe1c19070b5$var$filter.type = "highpass";
        $387effe1c19070b5$var$filter.frequency.value = Math.exp(value / 11); // Exponential scaling for highpass
    // console.log(filter.frequency.value);
    }
});
$387effe1c19070b5$var$filterControl.addEventListener("dblclick", ()=>{
    $387effe1c19070b5$var$resetFilter();
});
function $387effe1c19070b5$var$resetFilter() {
    $387effe1c19070b5$var$filterControl.value = 0;
    $387effe1c19070b5$var$filter.frequency.value = $387effe1c19070b5$var$filterControl.value;
    $387effe1c19070b5$var$filter.type = "allpass";
    $387effe1c19070b5$var$filter.frequency.value = $387effe1c19070b5$var$audioContext.sampleRate / 2; // Set to Nyquist frequency
// console.log("filter is neutral");
}
function $387effe1c19070b5$var$setupAudio() {
    $387effe1c19070b5$var$track.connect($387effe1c19070b5$var$distortion).connect($387effe1c19070b5$var$delay).connect($387effe1c19070b5$var$feedback).connect($387effe1c19070b5$var$delay).connect($387effe1c19070b5$var$panner).connect($387effe1c19070b5$var$filter).connect($387effe1c19070b5$var$audioContext.destination);
}
$387effe1c19070b5$var$setupAudio();
const $387effe1c19070b5$var$resetFxButton = document.getElementById("reset-fx");
function $387effe1c19070b5$var$initFx() {
    $387effe1c19070b5$var$resetControls($387effe1c19070b5$var$feedback.gain, $387effe1c19070b5$var$delayControl);
    $387effe1c19070b5$var$resetControls($387effe1c19070b5$var$panner.pan, $387effe1c19070b5$var$pannerControl);
    $387effe1c19070b5$var$resetDistortion();
    $387effe1c19070b5$var$resetFilter();
}
$387effe1c19070b5$var$initFx();
$387effe1c19070b5$var$resetFxButton.addEventListener("click", function() {
    $387effe1c19070b5$var$initFx();
});
window.addEventListener("resize", ()=>{
    $387effe1c19070b5$var$setupSongs();
    $387effe1c19070b5$var$setupSlider();
});
//audio toggle button
// function toggleAudio() {
//   if (playerDisplay) {
//     console.log("grid");
//     audioControls.style.display = "none"; // Hide audio controls
//     audioSection.style.position = "relative"; // Reset position
//     audioToggle.style.transform = "rotate(180deg)"; // Rotate button
//     sliderSection.style.display = "block";
//     playerDisplay = false;
//   } else {
//     console.log("show song");
//     playerDisplay = true;
//     audioControls.style.display = "flex"; // Show audio controls
//     audioSection.style.position = "absolute"; // Set to absolute
//     audioSection.style.display = "block"; // Ensure section is visible
//     audioToggle.style.transform = "rotate(0deg)"; // Reset rotation
//     sliderSection.style.display = "none";
//   }
// }
window.toggleAudio = $387effe1c19070b5$var$toggleAudio;
function $387effe1c19070b5$var$toggleAudio() {
    $387effe1c19070b5$var$playerDisplay = !$387effe1c19070b5$var$playerDisplay;
    const display = $387effe1c19070b5$var$playerDisplay ? "flex" : "none";
    const position = $387effe1c19070b5$var$playerDisplay ? "absolute" : "relative";
    const sliderDisplay = $387effe1c19070b5$var$playerDisplay ? "none" : "block";
    const rotate = $387effe1c19070b5$var$playerDisplay ? "rotate(0deg)" : "rotate(180deg)";
    $387effe1c19070b5$var$audioControls.style.display = display;
    $387effe1c19070b5$var$audioSection.style.position = position;
    $387effe1c19070b5$var$audioToggle.style.transform = rotate;
    $387effe1c19070b5$var$sliderSection.style.display = sliderDisplay;
}
const $387effe1c19070b5$var$spaceContainer = document.querySelector(".space-container");
const $387effe1c19070b5$var$emptySpace = document.querySelector(".empty-space");
const $387effe1c19070b5$var$eyeElements = document.querySelectorAll(".eyes");
console.log($387effe1c19070b5$var$eyeElements);
// function toggleEyes(element, color1, color2) {
//   const currentColor = element.style.fill || element.getAttribute("fill");
//   console.log(`current color ${currentColor}`);
//   newColor = currentColor === color1 ? color2 : color1;
//   console.log(newColor);
//   element.style.fill = newColor;
// }
// function triggerFace() {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       emptySpace.style.display = "flex";
//       resolve();
//     }, 1000);
//   }).then(() => {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         emptySpace.style.display = "none";
//         resolve();
//       }, 500);
//     });
//   });
// }
// function triggerFace() {
//   setTimeout(() => {
//     emptySpace.style.display = "flex";
//     setTimeout(() => {
//       emptySpace.style.display = "none";
//     }, 500);
//   }, 1000);
// }
// i need this
let $387effe1c19070b5$var$eyesVisible = false;
function $387effe1c19070b5$var$flickerFace() {
    let counter = 0;
    console.log("triggering flicker face");
    const flickerFaceInterval = setInterval(()=>{
        $387effe1c19070b5$var$emptySpace.style.display = $387effe1c19070b5$var$eyesVisible ? "none" : "flex";
        $387effe1c19070b5$var$eyesVisible = !$387effe1c19070b5$var$eyesVisible;
        console.log($387effe1c19070b5$var$eyesVisible);
        counter++;
        if (counter >= 4) clearInterval(flickerFaceInterval);
    }, 500);
}
if ($387effe1c19070b5$var$isPhoneSize) {
    fetch((0, (/*@__PURE__*/$parcel$interopDefault($f0da12febdf20ae2$exports)))).then((response)=>{
        return response.text();
    }).then((svgText)=>{
        $387effe1c19070b5$var$eyeElements.forEach((e)=>{
            e.innerHTML = svgText;
            const eyelid = e.querySelector(".eyelid");
            const pupil = e.querySelector(".pupil");
        // let counter = 0;
        // const flickerEyes = setInterval(() => {
        //   toggleEyes(eyelid, "rgb(0, 0, 0)", "rgb(255, 255, 255)");
        //   toggleEyes(pupil, "rgb(0, 0, 0)", "rgb(255, 255, 255)");
        //   counter++;
        //   if (counter >= 2) {
        //     clearInterval(flickerEyes);
        //     // console.clear();
        //   }
        // }, 500);
        });
    });
    const observer = new IntersectionObserver((entries)=>entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                console.log("intersection");
                $387effe1c19070b5$var$flickerFace();
            // observer.unobserve(entry.target);
            }
        }));
    observer.observe($387effe1c19070b5$var$spaceContainer);
}
if (!$387effe1c19070b5$var$isPhoneSize) $387effe1c19070b5$var$spaceContainer.style.display = "none";


//# sourceMappingURL=song-player.a264f9af.js.map
